import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { projects } from '../../helpers/constants';
import { usePublisher } from '../../helpers/functions/hooks/events';

const ScrollToTop = (): JSX.Element => {
    const location = useLocation();
    const lastHash = useRef<string>('');
    const publish = usePublisher();

    // listen to location change using useEffect with location as dependency
    // https://jasonwatmore.com/react-router-v6-listen-to-location-route-change-without-history-listen
    useEffect(() => {
        if (location.hash) {
            lastHash.current = location.hash.slice(1); // safe hash for further use after navigation
        }

        if (location.pathname.startsWith('/projects')) {
            setTimeout(() => {
                window.scrollTo({ top: 0 });
            }, 0);
            window.scrollTo({ top: 0 });
        }

        if (lastHash.current && document.getElementById(lastHash.current)) {
            let block: ScrollLogicalPosition = 'start';
            if (lastHash.current === projects.at(-1)?.title.replace(/\s/g, '-')) {
                block = 'end';
            }
            document
                .getElementById(lastHash.current)
                ?.scrollIntoView({ behavior: 'auto', block: block });
            if (lastHash.current === 'home') {
                publish('scrollProgress', 0);
            }
            lastHash.current = '';
        }
    }, [location, publish]);

    return (
        <></>
    );
}

export default ScrollToTop;
